var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupDocumentClip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 12,
    fill: "#E1E9F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0002 37.3337C15.2668 37.3337 14.6393 37.0728 14.1175 36.551C13.5948 36.0283 13.3335 35.4003 13.3335 34.667V13.3337C13.3335 12.6003 13.5948 11.9723 14.1175 11.4497C14.6393 10.9279 15.2668 10.667 16.0002 10.667H28.0002L34.6668 17.3337V34.667C34.6668 35.4003 34.4059 36.0283 33.8842 36.551C33.3615 37.0728 32.7335 37.3337 32.0002 37.3337H16.0002ZM16.0002 34.667H32.0002V18.667H26.6668V13.3337H16.0002V34.667ZM24.0002 33.3337C25.4891 33.3337 26.7504 32.8114 27.7842 31.767C28.8171 30.7225 29.3335 29.467 29.3335 28.0003V22.667H26.6668V28.0003C26.6668 28.7337 26.4113 29.3617 25.9002 29.8843C25.3891 30.4061 24.7557 30.667 24.0002 30.667C23.2668 30.667 22.6393 30.4061 22.1175 29.8843C21.5948 29.3617 21.3335 28.7337 21.3335 28.0003V20.667C21.3335 20.467 21.4002 20.3057 21.5335 20.183C21.6668 20.0612 21.8224 20.0003 22.0002 20.0003C22.2002 20.0003 22.3615 20.0612 22.4842 20.183C22.6059 20.3057 22.6668 20.467 22.6668 20.667V28.0003H25.3335V20.667C25.3335 19.7337 25.0113 18.9448 24.3668 18.3003C23.7224 17.6559 22.9335 17.3337 22.0002 17.3337C21.0668 17.3337 20.2779 17.6559 19.6335 18.3003C18.9891 18.9448 18.6668 19.7337 18.6668 20.667V28.0003C18.6668 29.467 19.1891 30.7225 20.2335 31.767C21.2779 32.8114 22.5335 33.3337 24.0002 33.3337ZM16.0002 13.3337V18.667V13.3337V34.667V13.3337Z",
    fill: "#0E2C66"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupDocumentClip);
export default __webpack_public_path__ + "static/media/GroupDocumentClip.b25e69c1e947c9ea31ea70721f184403.svg";
export { ForwardRef as ReactComponent };